import { ContextStore } from 'bernie-core';
import { Logger } from 'bernie-logger';
import { bffFetchPost, Headers } from './bff-fetch';

export interface ShortlistClient {
  id: string;
  token: string;
}

export class ShortlistApiSource {
  private host: string;
  private logger: Logger;
  private forwardedHeaders: Headers;
  private clientHeaders: Headers;
  private clientQueryParams: Headers;

  constructor(host = '', logger, forwardedHeaders: Headers = {}, client?: ShortlistClient) {
    this.host = host;
    this.logger = logger;
    this.forwardedHeaders = forwardedHeaders;
    this.clientHeaders = client
      ? {
          'client-token': client.token
        }
      : {};
    this.clientQueryParams = client
      ? {
          clientId: client.id
        }
      : {};
  }

  public fetch(api: string, context: ContextStore, data: any, category: string) {
    const headers = Object.assign({}, this.forwardedHeaders, this.clientHeaders);
    const queryParams = Object.assign({}, this.clientQueryParams);
    if (category) {
      Object.assign(queryParams, { configId: category });
    }

    return bffFetchPost(this.host, api, context, queryParams, this.logger, headers, data, false);
  }
}
